export const clientId = "d6d4cb3d3a866b9ceb00";
export const clientSecret = "bbaf08c344ca88fda378bc058223794f3882ed34";
export const owner = "itwxb";

export const nav = [
	{
		text: "生活笔记",
		path: "/article",
	},
	{
		text: "技术笔记",
		path: "/study",
	},
	{
		text: "我的项目",
		path: "/myitem",
	},
	{
		text: "文章收藏",
		path: "/note",
	},
	{
		text: "工具收藏",
		path: "/presentation",
	},
	{
		text: "留言板",
		path: "/messages",
	},
	{
		text: "关于我",
		path: "/about",
	},
	{
		text: "友情链接",
		path: "/friend",
	},
	{
		text: "50个项目",
		path: "/item50",
	},
];

export const article = {
	repo: "blog",
	label: "article",
};

export const study = {
	repo: "blog",
	label: "study",
};

export const algorithm = {
	repo: "blog",
	label: "algorithm",
};

export const note = {
	repo: "blog",
	label: "note",
};

export const presentation = {
	repo: "blogUse",
	filename: "README.md",
};

export const book = {
	repo: "itwxb.books",
};

export const friend = {
	items: [
		{
			name: "我的博客",
			url: "https://qmixi.cn/",
			avatar: "https://s2.loli.net/2022/11/27/QhkmBtI7xK2LGNb.jpg",
		},
		{
			name: "牧码哟-博客原作者,感谢大佬开源!",
			url: "https://guanpengchn.github.io/#/",
			avatar: "https://avatars.githubusercontent.com/u/13995641?v=4",
		},
	],
	libs: [
		{
			name: "Vue2",
			url: "https://github.com/vuejs/vue",
		},
		{
			name: "Vuetify",
			url: "https://github.com/vuetifyjs",
		},
		{
			name: "axios",
			url: "https://github.com/axios/axios",
		},
		{
			name: "marked",
			url: "https://github.com/markedjs/marked",
		},
		{
			name: "highlight.js",
			url: "https://github.com/highlightjs/highlight.js",
		},
		{
			name: "gulp",
			url: "https://github.com/gulpjs/gulp",
		},
		{
			name: "GitHub Corners",
			url: "https://github.com/tholman/github-corners",
		},
		{
			name: "Animated Books with CSS 3D Transforms",
			url:
				"https://tympanus.net/codrops/2013/07/11/animated-books-with-css-3d-transforms/",
		},
	],
};
